export const rtlCheck = (str) => {
  // this tests only if text contains hebrew 
  var result = str?(/[\u0590-\u05FF]/).test(str.charAt(0)):false;
  return result;
  // 	$rtl_chars_pattern = '/[\x{0590}-\x{05ff}\x{0600}-\x{06ff}]/u';
}

export default rtlCheck;